<template>
    <section>
        <!-- 検索窓 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" v-loading="toolbarLoading">
            <el-form :inline="true">
                <el-form-item>
                    <el-button type="primary" v-on:click="exportCsv" v-if="adminRole">CSV出力</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新規追加</el-button>
                </el-form-item>
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="30"
                           :total="total" style="float:right;">
                </el-pagination>
            </el-form>
        </el-col>
        <!-- /検索窓 -->

        <!-- リスト -->
        <el-table :data="movies" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
                  style="width: 100%;">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="状況" width="100">
                <template scope="scope">
                    <span v-if="scope.row.status === 'uploaded'">処理中</span>
                    <span v-else-if="scope.row.status === 'uploading'">アップロード中</span>
                    <span v-else-if="scope.row.status === 'uploadError'">失敗</span>
                    <span v-else-if="scope.row.status === 'transcoding'">変換中</span>
                    <span v-else-if="scope.row.status === 'transcoded'">トランスコード変換完了</span>
                    <span v-else-if="scope.row.status === 'drmConverting'">DRM変換中</span>
                    <span v-else-if="scope.row.status === 'drmConvertError'">DRM変換エラー</span>
                    <span v-else-if="scope.row.status === 'completed' && scope.row.drmStatus">完了</span>
                    <span v-else-if="scope.row.status === 'completed' && !scope.row.drmStatus">完了T</span>
                    <span v-else>エラー</span>
                </template>
            </el-table-column>
            <el-table-column label="動画名" width="400">
                <template scope="scope">
                    {{ scope.row.name }}
                    <span v-if="scope.row.mode == 2">
                        ({{ scope.row.mode }}D)
                    </span>
                    <span v-if="scope.row.mode == 3">
                        ({{ scope.row.mode }}D)
                    </span>
                    <span v-if="scope.row.mode == 4">
                        (SbS)
                    </span>
                    <span v-if="scope.row.mode == 5">
                        (T&B)
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="動画時間" width="200">
                <template scope="scope">
                    <span v-if="scope.row.duration > 0">{{ scope.row.duration | hhMMss }}</span>
                </template>
            </el-table-column>
            <el-table-column label="プレビュー" width="200">
                <template scope="scope">
                    <el-button type="success" size="small"
                               @click="previewVisible = true; previewSource = scope.row.id">
                        プレビュー
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="コンテンツ名" width="300">
                <template scope="scope">
                    <div v-for="(content, key) in (scope.row.contents)" :key="key">
                        {{ content }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="更新日時" width="210" prop="updatedAt" sortable>
                <template scope="scope">
                    {{ scope.row.updatedAt | formatDate }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button v-if="role !== 'general'" size="small" @click="handleEdit(scope.$index, scope.row)">編集</el-button>
                    <el-button v-if="role !== 'general'" type="danger" size="small" @click="handleDel(scope.$index, scope.row)">削除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- /リスト -->

        <!-- 一括削除 -->
        <el-col :span="24" class="toolbar" v-if="role !== 'general'">
            <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">一括削除</el-button>
        </el-col>
        <!-- /一括削除 -->

        <!-- 新規追加 -->
        <el-dialog title="新規追加" v-model="addFormVisible" :close-on-click-modal="false" :before-close="closeAddForm">
            <el-form :model="addForm" label-width="150px" :rules="addFormRules" ref="addForm">
                <el-form-item label="動画名接頭辞" prop="name">
                    <el-input v-model="addForm.name" auto-complete="off" @change="onChangeAddForm"></el-input>
                </el-form-item>
                <el-form-item label="トランスコード設定" prop="transcodeModeId" >
                    <el-select v-model="addForm.transcodeModeId" placeholder="選択して下さい" disabled>
                        <el-option v-for="item in addFormTranscodeMode"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="動画" prop="path">
                    <div v-if="addFormInputFileDisabled" class="el-form-item__error" style="position: initial !important;">
                      <p>動画接頭辞の入力内容を確認してから動画を選択してください</p>
                    </div>
                    <el-upload drag
                               class="upload-demo"
                               action="https://jsonplaceholder.typicode.com/posts/"
                               multiple
                               accept="video/mp4,video/x-m4v,video/*"
                               ref="upload"
                               :before-upload="beforeUpload"
                               :on-change="onChange"
                               auto-upload
                               :on-progress="onProgress"
                               :before-remove="beforeRemove"
                               :http-request="httpRequest"
                               :file-list="addFileList"
                               :disabled="addFormInputFileDisabled">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click.native="closeAddForm">閉じる</el-button>
            </div>
        </el-dialog>
        <!-- /新規追加 -->

        <!-- 編集 -->
        <el-dialog title="編集" v-model="editFormVisible" :close-on-click-modal="false" @close="closeEditForm">
            <el-form :model="editForm" label-width="150px" :rules="editFormRules" ref="editForm">
                <el-form-item label="ID" prop="id">
                    <el-input v-model="editForm.id" disabled></el-input>
                </el-form-item>
                <el-form-item label="動画名" prop="name">
                    <el-input v-model="editForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="トランスコード設定" prop="transcodeMode">
                    <el-select v-model="editForm.transcodeModeId" placeholder="選択して下さい" disabled>
                        <el-option v-for="item in allTranscodeMode"
                                   :key="item.id"
                                   :value="item.id"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="動画パス">
                    <el-input v-model="editForm.path" disabled auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="作成日時">
                    <el-date-picker type="datetime"
                                    placeholder="作成日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.createdAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="更新日時">
                    <el-date-picker type="datetime"
                                    placeholder="更新日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.updatedAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeEditForm">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /編集 -->

        <!-- 動画プレビュー -->
        <el-dialog title="プレビュー" v-model="previewVisible" size="full"
                   :close-on-click-modal="false"
                   @open="play()">
            <video ref="video" width="720px" controls autoplay></video>
        </el-dialog>
        <!-- /動画プレビュー -->
    </section>
</template>

<script>
    import * as MovieRequest from '../../api/movie';
    import * as TranscodeModeRequest from "../../api/transcodeMode";
    import ElOption from "../../../node_modules/element-ui/packages/select/src/option.vue";
    import ElUpload from "../../../node_modules/element-ui/packages/upload/src/index.vue";
    import config from "../../config/app";
    import { formatDate, hhMMss } from "../../components/filters/format";
    import Hls from "hls.js";
    import moment from "moment";
    import * as User from '../../api/cognitoUser';

    export default {
        components: {
            ElUpload,
            ElOption,
        },
        filters: {
            formatDate,
            hhMMss,
        },
        data() {
            return {
                getbucket: config.aws.s3.getbucket,

                // イメージ系
                modalImage: "",
                uploadDisable: false,

                movies: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [],
                allTranscodeMode: [],
                role: JSON.parse(sessionStorage.getItem('attributes'))['custom:role'],
                attributes: JSON.parse(sessionStorage.getItem('attributes')),
                user: JSON.parse(sessionStorage.getItem('user')),
                adminRole: User.checkAdminRoleBySession(),
                toolbarLoading: false,

                // 新規系
                addFormVisible: false,
                addLoading: false,
                addFormRules: {
                    name: [
                        { required: true, message: '動画名を入力してください', trigger: 'blur' }
                    ],
                    path: [
                        { validator: this.validatePath, trigger: "blur" }
                    ],
                    transcodeModeId: [
                        { required: true, message: 'トランスコード設定を選択してください', trigger: 'blur' }
                    ]
                },
                addForm: {
                    name: "",
                    mode: "2", // 2D固定
                    transcodeModeId: "",
                    sub: "",
                    username: "",
                },
                addFileList: [],
                uploadFileList: [],
                fileReader: new FileReader(),
                addFormInputFileDisabled: true,
                addFormTranscodeMode: [],

                // 編集系
                editFormVisible: false,
                editLoading: false,
                editFormRules: {
                    name: [
                        { required: true, message: '動画名を入力してください', trigger: 'blur' }
                    ],
                },
                editForm: {
                    name: "",
                    path: "",
                    mode: "2",　// 2D固定
                    transcodeModeId: "",
                    sub: "",
                    username: "",
                },

                previewVisible: false,
                previewSource: ""
            }
        },
        methods: {
            beforeRemove(file) {
              return this.$confirm(`${ file.name } : キャンセルしますか？`);
            },
            httpRequest(body) {
              this.$refs.addForm.validate(valid => {
                if (valid) {
                  this.addLoading = true;
                  const form = Object.assign({}, this.addForm);
                  const uploaded_file = body.file;
                  form.body = uploaded_file;
                  const prefix = form.name + '_';
                  form.name = prefix + uploaded_file.name;

                  MovieRequest
                      .add(form)
                      .then(res => {
                        // アップロードが終わったらリストから削除
                        for (var i = this.addFileList.length - 1; i >= 0; i--) {
                          let fileName = prefix + this.addFileList[i].name;
                          if (fileName == form.name) {
                            this.addFileList.splice(i, 1);
                          }
                        }
                        // 閉じるボタンの有効化監視用
                        for (var i = this.uploadFileList.length - 1; i >= 0; i--) {
                          let fileName = prefix + this.addFileList[i];
                          if (fileName == form.name) {
                            this.uploadFileList.splice(i, 1);
                          }
                        }
                        this.addLoading = false;
                        this.$message({
                          message: form.name + 'を登録しました',
                          type: 'success'
                        });
                      }).catch(res => {
                        // 閉じるボタンの有効化監視用
                        for (var i = this.uploadFileList.length - 1; i >= 0; i--) {
                          let fileName = prefix + this.addFileList[i];
                          if (fileName == form.name) {
                            this.uploadFileList.splice(i, 1);
                          }
                        }
                        console.log(res);
                        this.addLoading = false;
                        this.$message({
                          message: '登録に失敗しました',
                          type: 'warning'
                        });
                  });
                }
              });
            },
            beforeUpload(newFile) {
              this.uploadFileList.push(newFile.name);
              this.addFileList.push({
                name: newFile.name,
                url: '',
                file: newFile,
                status: 'ready',
                percentage: 0
              });
              return true;
            },
            onProgress(event) {
              let percent = (event.loaded / event.total * 100 || 0);
              this.event.percentage = percent;
            },
            validatePath(rule, value, callback) {
                console.log(this.$refs.upload.uploadFiles);
                if (this.$refs.upload.uploadFiles.length === 0) {
                    callback(new Error("ファイルを選択してください。"));
                } else {
                    callback();
                }
            },
            play() {
                this.$nextTick(() => {
                    if (Hls.isSupported() && this.previewSource.length > 0) {
                        MovieRequest.getIssueSignedUrl(this.previewSource)
                            .then(res => {
                                // console.log(res);
                                return res.data.manifest1;
                            })
                            .then(url => {
                                const video = this.$refs.video;
                                const hls = new Hls();
                                hls.attachMedia(video);
                                hls.loadSource(url);
                                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                                    video.play();
                                });
                            });
                    }
                });
            },
            onChange() {
                this.uploadDisable = this.$refs.upload.uploadFiles.length > 0;
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getApps();
            },
            getApps() {
                this.listLoading = true;
                const params = {
                    params: {
                        order: "updatedAt",
                        sort: "DESC",
                        count: config.pageCount,
                        offset: (this.page - 1) * config.pageCount,
                        sub: this.attributes['sub'],
                        username: this.user['username'],
                        fields: this.getSearchQueryFields(this.role),
                        q: this.attributes['sub'],
                    }
                };
                MovieRequest.count(params)
                    .then(res => {
                        this.total = res.data.count;
                    });
                MovieRequest
                    .search(params)
                    .then((res) => {
                        this.movies = res.data;
                        this.listLoading = false;
                    });
            },
            getTranscodeMode() {
                const params = {
                    params: {
                        sort: "DESC"
                    }
                }
                TranscodeModeRequest
                    .all(params)
                    .then((res) => {
                        this.allTranscodeMode = res.data;
                        this.addFormTranscodeMode = this.allTranscodeMode.filter(function(item) {
                            return item.name === '標準';
                        });
                    });
            },
            handleDel(index, row) {
                this.$confirm('削除してもよろしいですか？', '確認', {
                    type: 'warning'
                })
                .then(() => {
                    this.listLoading = true;
                    return MovieRequest.remove(row.id, row.path, row.status)
                    .then(() => {
                        this.$message({
                            message: '削除しました',
                            type: 'success'
                        });
                    })
                    .catch(err => {
                        this.$message({
                            message: 'コンテンツに紐付いた動画が含まれています。コンテンツを削除してから再度お試し下さい。',
                            type: 'warning'
                        });
                    });
                })
                .then(() => {
                    this.getApps();
                    this.listLoading = false;
                })
                .catch(err => {/*キャンセル*/});
            },
            handleAdd() {
                this.addFormVisible = true;
                this.addForm = {
                    name: "",
                    mode: "2", // 2D固定
                    transcodeModeId: this.addFormTranscodeMode.length > 0 ? this.addFormTranscodeMode[0].id : "",
                    sub: this.attributes['sub'],
                    username: this.user['username'],
                };
            },
            closeAddForm() {
                if(this.addFileList.length > 0) {
                  alert('動画アップロード中です。');
                  return;
                }
                this.$refs.upload.clearFiles();
                this.$refs.addForm.resetFields();
                this.addFormVisible = false;
                this.onChange();
                this.getApps();
            },
            closeEditForm() {
                this.$refs.editForm.resetFields();
                this.editFormVisible = false;
            },
            addSubmit() {
                this.$refs.addForm.validate(valid => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {}).then(() => {
                            this.addLoading = true;
                            const params = Object.assign({}, this.addForm);
                            const file = this.$refs.upload.uploadFiles[0];
                            params.body = file.raw;
                            params.path = file.name;

                            MovieRequest
                                .add(params)
                                .then(res => {
                                    this.addLoading = false;
                                    this.$message({
                                        message: '登録しました',
                                        type: 'success'
                                    });
                                    this.closeAddForm();
                                    this.getApps();
                                }).catch(() => {
                                    this.addLoading = false;
                                    this.$message({
                                        message: '登録に失敗しました',
                                        type: 'warning'
                                    });
                                    this.closeAddForm();
                                    this.getApps();
                                });
                        });
                    }
                });
            },
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                this.editForm.sub = this.attributes['sub'];
                this.editForm.username = this.user['username'];
            },
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {}).then(() => {
                            this.editLoading = true;
                            const params = Object.assign({}, this.editForm);
                            MovieRequest.edit(this.editForm.id, params).then(res => {
                                this.editLoading = false;
                                this.$message({
                                    message: '登録しました',
                                    type: 'success'
                                });
                                this.closeEditForm();
                                this.getApps();
                            });
                        });
                    }
                });
            },
            selsChange(sels) {
                this.sels = sels;
            },
            batchRemove() {
                const selectedItemInfo = this.sels.map(item => {
                    return {
                        id: item.id,
                        path: item.path,
                        status: item.status,
                    }
                });
                this.$confirm('選択した項目を削除してもよろしいですか？', '確認', {
                    type: 'warning'
                })
                .then(() => {
                    this.listLoading = true;
                    return MovieRequest.batchRemove(selectedItemInfo)
                    .then(() => {
                        this.$message({
                            message: '削除しました',
                            type: 'success'
                        });
                    })
                    .catch(err => {
                        this.$message({
                            message: 'コンテンツに紐付いた動画が含まれています。コンテンツを削除してから再度お試し下さい。',
                            type: 'warning'
                        });
                    });
                })
                .then(() => {
                    this.getApps();
                    this.listLoading = false;
                })
                .catch(() => {/*キャンセル*/});
            },
            onChangeAddForm() {
              this.addFormInputFileDisabled = !(this.addForm.name!="");
            },
            getSearchQueryFields(role) {
              if(role === 'general'){
                 return  "createdBy";
              }else {
                return  null;
              }
            },
            exportCsv: async function() {
                this.listLoading = true;
                this.toolbarLoading = true;
                // ヘッダ行
                const columns = [
                    'NO.',
                    '状況',
                    '動画名',
                    '動画時間',
                    'コンテンツ名',
                    'モード',
                    'トランスコード設定',
                    '更新日時',
                ];
                const header = columns.join(',') + '\n';

                // データ取得（全件）
                const params = {
                    params: {
                        order: 'updatedAt',
                        sort: 'DESC',
                        count: this.total,
                    }
                };
                const movie = await MovieRequest
                        .search(params)
                        .then(res => {
                            return res.data;
                        });

                const status = {
                    uploading: 'アップロード中',
                    uploadError: '失敗',
                    transcoding: '変換中',
                    transcoded: 'トランスコード変換完了',
                    drmConverting: 'DRM変換中',
                    drmConvertError: 'DRM変換エラー',
                    completed: '完了',
                };
                const mode = {
                    2: '2D',
                    3: '3D',
                    4: 'SbS',
                    5: 'T&B',
                };
                let arrMovie = [];
                for (var i = 0; i < movie.length; i++) {
                    const transcodeMode = this.allTranscodeMode.find((item) => item.id === movie[i].transcodeModeId);
                    const data = [
                        i + 1,
                        movie[i].status === 'completed' && !movie[i].drmStatus ? '完了T': status[movie[i].status] ? status[movie[i].status]: 'エラー',
                        movie[i].name,
                        movie[i].duration ? hhMMss(movie[i].duration): '',
                        '"' + movie[i].contents.join(',').replace(/"/g, '""') + '"',
                        mode[movie[i].mode] ? mode[movie[i].mode]: '',
                        transcodeMode ? transcodeMode.name: '',
                        formatDate(movie[i].updatedAt),
                    ];
                    arrMovie.push(data);
                }
                const body = arrMovie.join('\n');

                // CSVダウンロード
                const iconv = require("iconv-lite");
                const data = iconv.encode(header + body, 'windows-31j');
                const blob = new Blob([ data ], { "type" : "text/csv" });
                const url = window.URL.createObjectURL(blob);

                let link = document.createElement('a');
                link.download = 'swipe_movie_' + moment().format("YYYYMMDD") + '.csv';
                link.href = url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.listLoading = false;
                this.toolbarLoading = false;
            }
        },
        mounted() {
            this.getApps();
            this.getTranscodeMode();
        }
    }

</script>

<style scoped>
    .trim {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
    }
</style>



// WEBPACK FOOTER //
// Movie.vue?69814f42